import React from "react";
import PropTypes from "prop-types";
import { SectionWrap } from "./section.style";
import SwiperSlider, { SwiperSlide } from "../../../components/ui/swiper";
import { Container, Row, Col } from "../../../components/ui/wrapper";

import TechLogo from "../../../components/ui/tech-logo";

const Section = ({ sliderData, slider, sliderStyle, partners }) => {
  return (
    <SectionWrap>
      <Container>
        <Row>
          <Col lg={12}>
            <SwiperSlider settings={slider} {...sliderStyle}>
              {partners.map((partner, i) => (
                <SwiperSlide key={`partner-${i}`}>
                  <figure className="image">
                    <img src={partner.node.image.publicURL} alt={partner.node.id} />
                  </figure>
                </SwiperSlide>
              ))}
            </SwiperSlider>
          </Col>
        </Row>
      </Container>
    </SectionWrap>
  );
};

Section.propTypes = {
  sliderData: PropTypes.array,
  slider: PropTypes.object
};

Section.defaultProps = {
  slider: {
    slidesPerView: 6,
    loop: true,
    speed: 1000,
    spaceBetween: 30,
    autoplay: {
      delay: 2500
    },
    breakpoints: {
      320: {
        slidesPerView: 2
      },
      575: {
        slidesPerView: 3
      },
      767: {
        slidesPerView: 4
      },
      991: {
        slidesPerView: 5
      },
      1499: {
        slidesPerView: 6
      }
    }
  },
  sliderStyle: {
    align: "center"
  }
};

export default Section;
